import * as analytics from 'analytics-core';
import getAppState from 'app-state';
import {Config} from './types';
import enablePurchaseTracking from './enablePurchaseTracking';
import fbq from './fbq';

let isInitialized = false;

export default function init() {
    if (isInitialized) {
        return this;
    }
    isInitialized = true;

    const config = getAppState<Config>('facebookAnalytics', {});
    const enabled = analytics.getAllowAnalytics() && !!(config.id);

    if (enabled) {
        const script = document.createElement('script');
        script.async = true;
        script.src = config.apiSrc;
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);

        fbq('init', config.id);
        fbq('track', 'PageView');
    }

    enablePurchaseTracking();

    return this;
}
